import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Divider = styled.hr`
  border: none;
  background-color: #f8f8f8;

  &.vertical {
    position: relative;
    top: -1px;
    display: inline-block;
    width: 1px;
    height: 12.5px;
    vertical-align: middle;
    background-color: #dadada;
  }

  &.horizontal {
    display: block;
    width: 100%;
    height: 10px;
  }
`

const CommonDivider = ({ size = 8, type = 'vertical', ...props }) => {
  const dividerStyle = {
    margin: type === 'vertical' ? `0 ${size}px` : `${size}px 0`,
  }

  return (
    <Divider
      className={type}
      {...props}
      style={{ ...dividerStyle, ...props.style }}
    />
  )
}

CommonDivider.prototypes = {
  size: PropTypes.number,
}

export default CommonDivider
